/*
Example of a FilterObject with 2 groups. The first with 2 conditions, The second with 1 condition:

{
	"type":"or",
	"conditionList":[
	   {
		  "type":"and ",
		  "conditionList":[
			 {
				"source":"aaaa",
				"condition":"is",
				"conditionValue":"aaaa"
			 },
			 {
				"source":"bbbb",
				"condition":"is_not",
				"conditionValue":"bbbb"
			 }
		  ]
	   },
	   {
		  "type":"and ",
		  "conditionList":[
			 {
				"source":"cccc",
				"condition":"is_not",
				"conditionValue":"cccc"
			 }
		  ]
	   }
	]
 }

 */

/* Private */
import { v4 as uuid } from 'uuid';
import { OperandTypes, ConditionTypes, ConditionValueTypes } from '@ply-io/conditions';

const predicateParams = (source, conditionValue) => ({
	id: uuid(),
	source,
	condition: ConditionTypes.Is,
	conditionValue,
	conditionValueType: ConditionValueTypes.SingleItem,
});

const conditionGroup = (type, conditionList) => ({
	id: uuid(),
	type,
	conditionList,
});

const newEmptyPredicate = () => predicateParams('', '');

const newEmptyCondition = (type) => conditionGroup(type, [newEmptyPredicate()]);

/* Public */

const getInitialTableFilterObj = () => ({
	type: OperandTypes.Or,
	conditionList: [newEmptyCondition(OperandTypes.And)],
});

const getInitialTableFilterObjWithValue = (item) => ({
	type: OperandTypes.Or,
	conditionList: [conditionGroup(OperandTypes.And, [{ ...item, conditionValueType: ConditionValueTypes.SingleItem }])],
});

const addConditionGroup = (filterObject) => {
	filterObject.conditionList.push(newEmptyCondition(OperandTypes.And));
};

const addPredicateToConditionGroup = (conditionGroupToAddTo) => {
	conditionGroupToAddTo.conditionList.push(newEmptyPredicate());
};

const removePredicateFromConditionGroup = (groupOfConditions, conditionGroupToRemoveFrom, conditionId) => {
	const conditionGroupToRemoveFromId = conditionGroupToRemoveFrom.id;
	const newConditionList = conditionGroupToRemoveFrom.conditionList.filter((x) => x.id !== conditionId);
	conditionGroupToRemoveFrom.conditionList = newConditionList;
	if (newConditionList.length === 0) {
		// remove empty operands
		const newGroupConditionList = groupOfConditions.conditionList.filter((x) => x.id !== conditionGroupToRemoveFromId);
		groupOfConditions.conditionList = newGroupConditionList;
	}
};

function isConditionGroupFull(conditionGroup) {
	return conditionGroup && conditionGroup.source && conditionGroup.condition;
}

const TableFilterService = {
	getInitialTableFilterObj,
	getInitialTableFilterObjWithValue,
	addConditionGroup,
	addPredicateToConditionGroup,
	isConditionGroupFull,
	removePredicateFromConditionGroup,
};

export default TableFilterService;
